import { Component, OnInit,AfterViewInit } from '@angular/core';
import {GeneralService} from "../services/general.service"
import { MatTableDataSource } from '@angular/material/table';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
declare var $ : any
@Component({
  selector: 'app-param-action',
  templateUrl: './param-action.component.html',
  styleUrls: ['./param-action.component.scss']
})
export class ParamActionComponent implements OnInit , AfterViewInit
{
  exist=true;
  successLoadData = false;
  data;
  dataSource;
  displayedColumns=["avtParamAction_Code", 
                    "avtParamAction_Description",    
                    // "avtParamAction_Public",
                    "avtParamAction_Facture",
                    // "avtParamAction_Presence",
                    // "avtParamAction_Client",
                    // "avtParamAction_Hotel",
                    // "avtParamAction_Repas",
                    // "avtParamAction_Info",
                     "action",
                    // "avtParamAction_Opsolet",
                    "avtParamAction_Color"];
  showParamAction=true;
  buttonModifier = {show:true,text:"Modifier"};
  buttonConsulter = {show:false,text:""};
  buttonSupprimer =  {show:true,text:"Suprimer"}; 
  showInoutTab={avtParamAction_Code:true,avtParamAction_Description:true,avtParamAction_Public:true,avtParamAction_Presence:true,avtParamAction_Hotel:true,avtParamAction_Repas:true,avtParamAction_Info:true,avtParamAction_Default:true,avtParamAction_Opsolet:true};
  row;
  InitParamAction;
  typeAction = this.generalService.typeAction;
  constructor(public generalService: GeneralService) { }
  ngAfterViewInit()
  {
    this.setColorCemponon()
  }
  ngOnInit() 
  {
    this.data = {};
    this.getInitParamAction()
    this.setDataSource();
  }
  setColorCemponon()
  {
    $('#btn-color-action').spectrum
    ({
      type: "component",
      change: (color)=>
      {
        this.data.avtParamAction_ColorAction = color.toHexString(); // #ff0000
      }
    });
    $('#btn-color-text').spectrum
    ({
      type: "component",
      change: (color)=>
      {
        this.data.avtParamAction_ColorText = color.toHexString(); // #ff0000
      }
    });
  }
  showColor(id)
  {
    $("#"+id).spectrum("toggle");
    return false;
  }
  getInitParamAction()
  {
    this.generalService.rechercheTable(this.generalService.urlParamAction).subscribe(data =>
    {
      this.InitParamAction = data;
      this.data = data.avtParamAction[0];
    })
  }
  setToBoolean(paramAction)
  {
    for(var i=0;i<paramAction.length;i++)
    {
      // paramAction[i].avtParamAction_Public = paramAction[i].avtParamAction_Public.toString().toLowerCase() == 'true';
      paramAction[i].avtParamAction_Facture = paramAction[i].avtParamAction_Facture.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Client = paramAction[i].avtParamAction_Client.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Presence = paramAction[i].avtParamAction_Presence.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Hotel = paramAction[i].avtParamAction_Hotel.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Repas = paramAction[i].avtParamAction_Repas.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Info = paramAction[i].avtParamAction_Info.toString().toLowerCase() == 'true';
      //paramAction[i].avtParamAction_Default = paramAction[i].avtParamAction_Default.toString().toLowerCase() == 'true';
      // paramAction[i].avtParamAction_Opsolet = paramAction[i].avtParamAction_Opsolet.toString().toLowerCase() == 'true';
    }
    return paramAction
  }

  setDataSource()
  {
    this.generalService.rechercheTable(this.generalService.urlListeParamAction).subscribe(paramAction =>
    {
      paramAction.forEach(param =>
      {
        param["action"] = this.typeAction.find(type => {return type.value == param.avtParamAction_Default}).text
      });
      this.dataSource = new MatTableDataSource(this.setToBoolean(paramAction));  
      this.successLoadData = true;
    });
  }
  fillParamAction(InitParamAction,data)
  {
    InitParamAction.avtParamAction[0].avtParamAction_Code = data.avtParamAction_Code.toString();    
    InitParamAction.avtParamAction[0].avtParamAction_Description = data.avtParamAction_Description.toString();

    InitParamAction.avtParamAction[0].avtParamAction_Client = (data.avtParamAction_Client);
    InitParamAction.avtParamAction[0].avtParamAction_Facture = (data.avtParamAction_Facture);
    InitParamAction.avtParamAction[0].avtParamAction_Public = (data.avtParamAction_Public);
    InitParamAction.avtParamAction[0].avtParamAction_Presence = (data.avtParamAction_Presence);
    InitParamAction.avtParamAction[0].avtParamAction_Hotel = (data.avtParamAction_Hotel);
    InitParamAction.avtParamAction[0].avtParamAction_Repas = (data.avtParamAction_Repas);
    InitParamAction.avtParamAction[0].avtParamAction_Info = (data.avtParamAction_Info);
    InitParamAction.avtParamAction[0].avtParamAction_Default = (data.avtParamAction_Default);
    InitParamAction.avtParamAction[0].avtParamAction_Opsolet = (data.avtParamAction_Opsolet);
    InitParamAction.avtParamAction[0].avtParamAction_ColorText = (data.avtParamAction_ColorText);
    InitParamAction.avtParamAction[0].avtParamAction_ColorAction = (data.avtParamAction_ColorAction);
  }
  generateCode()
  {
    var avtParamAction_Code : number = parseInt(this.dataSource.data.reduce((max, code) => parseInt(code.avtParamAction_Code) > max ? parseInt(code.avtParamAction_Code) : max, parseInt(this.dataSource.data[0].avtParamAction_Code))) ;
    this.data.avtParamAction_Code  = avtParamAction_Code + 1;
    var compte:number =3- this.data.avtParamAction_Code.toString().length
    for(var i=0; i< compte;i++)
    {
      this.data.avtParamAction_Code = "0" + this.data.avtParamAction_Code;
    }
  }
  ajouter(f)
  {
    if (f.form.valid) 
    {
      this.generateCode();
      if(!this.existeTypeAction())
      {
        if(this.InitParamAction != undefined)
        {
          this.exist = false;
          this.generalService.enregisterTable(this.InitParamAction).subscribe(data =>
          {
            this.exist = true;
            this.generalService.dialogSuccess("Enregistré",true);
            this.setDataSource();
          },
          err =>
          {
            this.exist = true;
            this.generalService.dialogSuccess("Non enregistré",false);
          })
        }
        else
        {
          this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
        }
      }
      else
      this.generalService.dialogSuccess("Le type d'action saisie existe déjà",false)
    }
  }
  existeTypeAction() : boolean
  {
    if(this.dataSource.data.find(typeAction => {return typeAction.avtParamAction_Code == this.data.avtParamAction_Code || typeAction.avtParamAction_Description == this.data.avtParamAction_Description })== undefined)
      return false;
    else
      return true
  }
  selectRow(event, row) 
  {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function(el)
    {      
      el.style="";
    });
    event.currentTarget.style="background-color: #a0bdf3;";
    this.row = row; 
    this.setRow();
  }
  modifier(f)
  {
    if(this.row != undefined)
    {
      if (f.form.valid) 
      {
          this.exist = false;
        this.generalService.rechercheTable(this.generalService.urlParamAction+"&val="+this.data.avtParamAction_Code).subscribe(data =>
        {
          this.fillParamAction(data,this.data);
          this.generalService.enregisterTable(data).subscribe(d =>
          {
            this.exist = true;
            this.generalService.dialogSuccess("Enregistré",true);
            this.setDataSource();
          },
          err =>
          {
            this.exist = true;
            this.generalService.dialogSuccess("Non enregistré",true);
          })
        })
      }
    }
    else
      this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
  setRow()
  {
    this.data.avtParamAction_Code=this.row.avtParamAction_Code  ;
    this.data.avtParamAction_Description =this.row.avtParamAction_Description ;
    this.data.avtParamAction_Public=this.row.avtParamAction_Public  ;
    this.data.avtParamAction_Facture=this.row.avtParamAction_Facture  ;
    this.data.avtParamAction_Client=this.row.avtParamAction_Client  ;
    this.data.avtParamAction_Presence =this.row.avtParamAction_Presence ;
    this.data.avtParamAction_Hotel =this.row.avtParamAction_Hotel ;
    this.data.avtParamAction_Repas =this.row.avtParamAction_Repas ;
    this.data.avtParamAction_Info=this.row.avtParamAction_Info  ;
    this.data.avtParamAction_Default =this.row.avtParamAction_Default ;
    this.data.avtParamAction_Opsolet =this.row.avtParamAction_Opsolet ;
    this.data.avtParamAction_ColorText=this.row.avtParamAction_ColorText 
    this.data.avtParamAction_ColorAction = this.row.avtParamAction_ColorAction 
    $("#btn-color-text").spectrum("set", this.data.avtParamAction_ColorText);
    $("#btn-color-action").spectrum("set", this.data.avtParamAction_ColorAction);
  }
  supprimer()
  {
    if(this.row != undefined)
    {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(this.row.avtParamAction_Code,"avtParamAction");
          if(deleteFn != null)
          {
            this.exist = false;
            deleteFn.subscribe(data => 
            {
              this.setDataSource()
              this.generalService.dialogSuccess("Elément supprimer",true);
              this.exist = true;
            },
            error =>
            {
                this.generalService.dialogSuccess("Elément non supprimé",false);
                this.exist = true;
            });
          }
        }
        if(result == "annuler")
        {
        }
      });

    }
    else
      this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
}